import { combineReducers } from "redux";
import { digitalShare, IDigitalShareReducer } from "./DigitalShareReducer";
import { IGPSInsightsState, mobilyticsReportOutput } from "./GPSInsightsReducer";
import { ILoadScoutReducerState, loadScout } from "./LoadScoutReducer";
import { IReportMapState, reportMap } from "./ReportMapReducer";
import { IRetailMatchState, matchReportOutput } from "./RetailMatchReducer";
import { IUserReducerState, user } from "./UserReducer";

export interface IShareReducer {
    mobilyticsReportOutput: IGPSInsightsState;
    matchReportOutput: IRetailMatchState;
    loadScout: ILoadScoutReducerState;
    user: IUserReducerState;
    reportMap: IReportMapState;
    digitalShare: IDigitalShareReducer;
}

export const shareReducer = combineReducers<IShareReducer>({
    mobilyticsReportOutput,
    matchReportOutput,
    loadScout,
    user,
    reportMap,
    digitalShare,
});
